import { ReactNode } from 'react';

import { withIcon } from '../../core/components/Icon.tsx';
import classnames from '../../core/utils/classnames.tsx';

interface PromptRowProps {
    icon: ReturnType<typeof withIcon>;
    text: ReactNode;
    description?: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    iconClassName?: string;
}

const ROW_CLASS_NAME =
    'flex w-full items-center gap-2 rounded-lg border border-solid border-line-weak bg-surface-weak px-5 py-4';

const PromptRow = ({
    icon: PromptIcon,
    text,
    description,
    onClick,
    disabled = false,
    iconClassName = 'text-content-strong',
}: PromptRowProps) => {
    const content = (
        <>
            <PromptIcon className={classnames('flex-none w-4', iconClassName)} />
            <div className="flex min-w-0 justify-between w-full flex-row">
                <span className="text-sm font-medium text-content-strong">{text}</span>
                {description && <span className="text-xs text-content-weak">{description}</span>}
            </div>
        </>
    );
    if (!onClick || disabled) {
        return <div className={classnames(ROW_CLASS_NAME, disabled && 'opacity-50 cursor-not-allowed')}>{content}</div>;
    }
    return (
        <button
            type="button"
            onClick={onClick}
            className={classnames(
                ROW_CLASS_NAME,
                'cursor-pointer text-left transition-colors hover:bg-surface-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-brand-strong'
            )}
        >
            {content}
        </button>
    );
};

export default PromptRow;
